import L from 'leaflet'
import 'leaflet.locatecontrol'
import {GeoSearchControl, JsonProvider, OpenStreetMapProvider} from 'leaflet-geosearch'
import CustomProvider from "./Provider";
export default class Maps {

    constructor(ID, lng, lat, zoom, loader) {
        this.lng = lng
        this.lat = lat
        this.map = new L.Map(ID, {
            center: new L.LatLng(this.lat, this.lng),
            zoom: zoom,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            gestureHandling: true
        })
        this.marker = ''
        this.layersFromTerms = L.featureGroup()
        this.layersFromKeywords =  L.featureGroup()
        this.layersFromID =  L.featureGroup()
        this.termsLayers = []
        this.keywordsLayers = []
        this.idLayers = []
        this.loader = loader
        this.filters = document.getElementById('filters-maps')
        this.keywordHasResult = 0
        this.mapParams = {
            includeAllMarker: false,
            isPreview: false
        }
    }

    /**************
     * Init the map and display it
     *
     ***************/
    get init() {
        // Init the map
        // Source : https://leaflet.github.io/Leaflet.draw/docs/examples/full.html

        let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            osmAttrib = '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            osm = L.tileLayer(osmUrl, {attribution: osmAttrib});
        osm.addTo(this.map)

        let satelliteView = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            {
                attribution: 'Source: Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
            }
        )

        let baseMaps = {
            "<img src='/wp-content/plugins/creasit-maps/assets/dist/front/images/osm.png' />": osm,
            "<img src='/wp-content/plugins/creasit-maps/assets/dist/front/images/satellite.png' />": satelliteView
        }

        L.control.layers(baseMaps, null, {position: 'bottomright'}).addTo(this.map);

        L.Icon.Default.prototype.options.iconUrl = 'creasit-marker.png'
        L.Icon.Default.prototype.options.iconSize = [30, 42]
        L.Icon.Default.prototype.options.iconRetinaUrl = ''

        L.control.zoom({
            position: 'bottomright',
            zoomInTitle: 'Zoomer',
            zoomOutTitle: 'Dézoomer'
        }).addTo(this.map)

        let provider = new CustomProvider()

        let searchControl = new GeoSearchControl({

            position: 'topright',
            style: 'button',
            showMarker: true,
            showPopup: false,
            popupFormat: ({query, result}) => '<div class="geo-search">' + result.label + '</div>',
            // popupFormat: ({result}) => `${result.label}`,
            // resultFormat: ({result}) => `${result.label}`,
            marker: {
                icon: L && L.Icon ? new L.Icon.Default() : undefined,
                draggable: false,
            },
            maxMarkers: 1,
            maxSuggestions: 5,
            retainZoomLevel: true,
            animateZoom: true,
            searchLabel: "Rechercher une adresse",
            notFoundMessage: "Aucun résultat à cette adresse",
            // messageHideDelay: 3000,
            zoomLevel: 30,
            classNames: {
                container: 'leaflet-bar leaflet-control leaflet-control-geosearch',
                button: 'leaflet-bar-part leaflet-bar-part-single',
                resetButton: 'reset',
                msgbox: 'leaflet-bar message',
                form: '',
                input: '',
            },
            // autoComplete: true,
            // autoCompleteDelay: 250,
            // autoClose: false,
            // keepResult: false,
            // updateMap: true,
            provider: provider,
        })

        //console.log(searchControl)

        this.map.addControl(searchControl)

        this.map.on('geosearch/showlocation', function (event) {
            this.flyToBounds(event.location.bounds, {
                padding: [100, 100]
            })
        })

        L.control.locate({
                position: 'topright',
                showPopup: false,
                markerClass: L.marker,
                keepCurrentZoomLevel: true,
                drawCircle: false,
                icon: 'fa fa-crosshairs',
                flyTo: true,
                strings: {
                    title: "Indiquer ma position",
                },
                locateOptions: {
                    maxZoom: 15
                },
            }
        ).addTo(this.map);

        L.Polygon.addInitHook(function() {
            this._latlng = this._bounds.getCenter();
        });
        L.Polyline.addInitHook(function() {
            this._latlng = this._bounds.getCenter();
        });


        this.map.addLayer(this.layersFromTerms);
        this.map.addLayer(this.layersFromKeywords);
        this.map.addLayer(this.layersFromID);

    }

    /**************
     * Add markers on map, by selected terms
     ***************/
    addMarkers(termsID, keyword, id) {
        // Init the PostsQuery Class
        let Query = new PostsQuery()

        // Set the custom creasit api route
        Query._APIRoute = 'maps'

        // Get API endpoint (= url)
        let URL = Query.getURL(this.mapParams);


        // Display loader
        this.loader.classList.add('load')
        if (this.filters !== null) {
            this.filters.classList.add('load')
        }

        Query.fetchAPI(URL, 'GET').then(
            data => {

                if (!!termsID) {
                    this.searchByTerms(termsID, data)
                }
                if (!!keyword) {
                    this.searchByKeywords(keyword, data)
                }

                if (!!id) {
                    this.searchByID(id, data)
                }

                // Remove loader when data sent
                this.loader.classList.remove('load')
                if (this.filters !== null) {
                    this.filters.classList.remove('load')
                }
            }
        ).catch(err => {
            // TODO handle error to send
            console.log(err)
        })
    }

    searchByID(ids, data) {
        let i = 0
        data.forEach((elements) => {
            ids.forEach((id) => {
                if (elements.ID === Number(id)) {
                    this.idLayers[i] = [];

                    this.marker = new L.DivIcon({
                        iconSize: [40, 57], // size of the icon
                        iconAnchor: [23, 56],
                        popupAnchor: [-3, -55],
                        className: 'creasit-marker ' + elements.main_term.term_icon
                    })
                    this.createMarker(elements, i, 'id')
                    i++
                }
            })
        })

        this.map.flyToBounds(this.layersFromID, {
            padding: [100, 100]
        })
    }

    searchByKeywords(keyword, data) {
        const $keywordsFilter = document.getElementById('mapKeywordsFilter')
        const $keywordsController = document.getElementById('mapKeywordsController')
        const container = $keywordsFilter.closest('.filter__select-wrapper')
        this.keywordHasResult = 0

        data.forEach((elements) => {
            let modifiedElements = this.findValueOfProperty(elements, keyword)
            if (modifiedElements.isValid === true) {
                elements = modifiedElements.newElements
                this.keywordHasResult++
                this.keywordsLayers[this.keywordHasResult] = [];

                this.marker = new L.DivIcon({
                    iconSize: [40, 57], // size of the icon
                    iconAnchor: [23, 56],
                    popupAnchor: [-3, -55],
                    className: 'creasit-marker ' + elements.main_term.term_icon
                })
                this.createMarker(elements, this.keywordHasResult, 'keywords')
            }
        })


        if (this.keywordHasResult > 0) {
            this.map.flyToBounds(this.layersFromKeywords.getBounds(), {
                padding: [100, 100]
            })
            $keywordsController.classList.add('reset-filter')
            container.classList.remove('no-result')
        } else {
            $keywordsController.classList.add('reset-filter')
            container.classList.add('no-result')
        }
    }

    findValueOfProperty(obj, propertyName) {
        let reg = new RegExp(propertyName.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), "i")// "i" to make it case insensitive
        let isValid = ''
        let newPlaces = []
        let returnedObj = {}
        for (const [key, value] of Object.entries(obj)) {
            if (key === 'places') {
                value.forEach((place) => {
                    isValid = reg.test(place.description)
                    if (isValid === true) {
                        newPlaces.push(place)
                    }
                })
            } else if (key === 'post_title') {
                isValid = reg.test(value.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
                if (isValid === true) {
                    returnedObj.isValid = isValid
                    returnedObj.newElements = obj
                    return returnedObj
                }
            }
        }
        obj.places = newPlaces
        returnedObj.isValid = isValid
        returnedObj.newElements = obj
        return returnedObj
    }

    searchByTerms(termsID, data) {
        // For each terms selected (can be 1 parent, or 1 parent and many children)
        for (let i = 0; i < termsID.length; i++) {
            // Init array of layers by term
            this.termsLayers[termsID[i]] = [];

            // For each posts
            data.forEach((elements) => {
                this.marker = new L.DivIcon({
                    iconSize: [40, 57], // size of the icon
                    iconAnchor: [23, 56],
                    popupAnchor: [-3, -55],
                    className: 'creasit-marker ' + elements.main_term.term_icon
                });
                // If term defined and included in post
                if (termsID[i] !== undefined && elements.terms.includes(termsID[i])) {
                    // For each place in post
                    this.createMarker(elements, termsID[i], 'terms')
                }
            })
            this.map.flyToBounds(this.layersFromTerms.getBounds(), {
                padding: [100, 100]
            })
        }
    }

    createMarker(elements, index, type) {
        elements.places.forEach((place) => {
            // Get marker coordinates
            const mapElements = JSON.parse(place.marker);
            let hrefExport = ""
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                hrefExport = 'maps://maps.apple.com/?q=' + mapElements.geometry.coordinates[1] + ',' + mapElements.geometry.coordinates[0]
            } else if (/Android/i.test(navigator.userAgent)) {
                hrefExport = 'geo:' + mapElements.geometry.coordinates[0] + ',' + mapElements.geometry.coordinates[1]
            } else {
                hrefExport = 'https://www.openstreetmap.org/directions?to=' + mapElements.geometry.coordinates[1] + '%2C' + mapElements.geometry.coordinates[0] + '#map=17/' +  mapElements.geometry.coordinates[1] + '/' + mapElements.geometry.coordinates[0]
            }
            // Construct marker popup with all infos (do another function to get these infos ?)
            let contentPopup = '<div class="marker-popup">'
            contentPopup += '<h2 class="marker-popup__title">' + elements.post_title + '</h2>'
            contentPopup += '<p class="marker-popup__category">' + elements.main_term.name + '</p>'
            if (place.address_group.address || place.address_group.additional_address || place.address_group.zip_code || place.address_group.city || (mapElements.geometry.type === "Point" && !("radius" in mapElements.properties) )){
                contentPopup += '<div class="marker-popup__location">'
                contentPopup += '<svg width="28" height="35" aria-hidden="true" viewBox="0 0 28 35" xmlns="http://www.w3.org/2000/svg"> <path d="M13.9983 0.0390625C6.3069 0.0390625 0.153809 6.17775 0.153809 13.8511C0.153809 25.4464 12.46 34.6544 13.9983 34.6544C15.5365 34.6544 27.8427 25.4464 27.8427 13.8511C28.0136 6.17775 21.6896 0.0390625 13.9983 0.0390625ZM13.9983 19.9898C10.5799 19.9898 7.84518 17.2615 7.84518 13.8511C7.84518 10.4407 10.5799 7.71242 13.9983 7.71242C17.4167 7.71242 20.1514 10.6113 20.1514 13.8511C20.1514 17.091 17.4167 19.9898 13.9983 19.9898Z"/></svg>'
                contentPopup += '<p class="marker-popup__address">' + place.address_group.address + '</p>'
                contentPopup += '<p class="marker-popup__additional-address">' + place.address_group.additional_address + '</p>'
                contentPopup += '<p class="marker-popup__zipcity">' + place.address_group.zip_code + ' ' + place.address_group.city + '</p>'
                contentPopup += (mapElements.geometry.type === "Point" && !("radius" in mapElements.properties) ) ? '<a href="' + hrefExport + '" title="Calculer un itinéraire" target="_blank" class="marker-popup__itinerary"><span>Calculer un itinéraire</span></a>' : ""
                contentPopup += '</div>'
            }

            if (place.image || place.description || place.link.href) {
                contentPopup += '<div class="marker-popup__content">'
                if (place.image) {
                    contentPopup += '<img width="80" height="80" src="' + place.image.sizes.thumbnail + '"  alt="' + place.image.alt + '"/>'
                }
                contentPopup += '<div class="marker-popup__description">'
                contentPopup += place.description
                if (place.link.href) {
                    let target = ''
                    if (place.link.type === 'external') {
                        target = 'target="_blank"'
                    }
                    contentPopup += '<a class="marker-popup__link button" href="' + place.link.href + '" title="' + place.link.title + '" ' + target + '">En savoir plus</a>'
                }

                contentPopup += '</div>'
                contentPopup += '</div>'
            }
            contentPopup += '</div>'


            //console.log(mapElements)
            new L.GeoJSON(mapElements, {
                // Init marker points
                pointToLayer: (feature, latlng) => {
                    if (feature.properties.radius) {
                        return new L.Circle(latlng, feature.properties.radius, {color: elements.layer_color});
                    } else {
                        return new L.Marker(latlng, {
                            icon: this.marker,
                            draggable: false,
                        });
                    }
                },
                // Add it to termsLayers (to save them by terms) AND to layersFromTerms (to display it on map)
                onEachFeature: (feature, layer) => {
                    if (feature.geometry.type !== 'Point') {
                        layer.setStyle({
                            color: elements.layer_color
                        })
                    }
                    if (type === 'terms') {
                        layer.bindPopup(contentPopup, {maxWidth: 399})
                        this.termsLayers[index].push(layer)
                        this.layersFromTerms.addLayer(layer)
                    } else if (type === 'keywords') {
                        layer.bindPopup(contentPopup, {maxWidth: 399})
                        this.keywordsLayers[index].push(layer)
                        this.layersFromKeywords.addLayer(layer)

                    } else if (type === 'id') {
                        layer.bindPopup(contentPopup, {maxWidth: 399})
                        this.idLayers[index].push(layer)
                        this.layersFromID.addLayer(layer)
                    }
                },
            })


        })
    }

    /**************
     * Remove markers on map, by selected terms
     ***************/
    removeMarkers(termsID) {
        // For each terms selected
        for (let i = 0; i < termsID.length; i++) {
            // Get every layers by terms
            this.termsLayers[termsID[i]].forEach(layer =>
                // Remove layers from map
                this.layersFromTerms.removeLayer(layer)
            )
        }
    }


    /**************
     * Remove markers on map, by selected terms
     ***************/
    resetTermsMarkers() {
        this.layersFromTerms.clearLayers()
    }

    /**************
     * Remove markers on map, by selected terms
     ***************/
    resetKeywordsMarkers() {
        this.layersFromKeywords.clearLayers()
    }
}
